export default __webpack_public_path__ + "static/media/icon_winner.869a2f93.svg";